import _ from 'underscore';
import Backbone from 'backbone';
import BrowserDetect from '@/vendor/browser_detect';
import MapStatesTemplate from '@/templates/data/map-states.hbs';

window.google.charts.load('current', {
  packages: ['geochart'],
  mapsApiKey: 'AIzaSyDHCIRLp--YyQVLdWoJxZKbEIex5Z_TyJs',
});

export default Backbone.View.extend({
  template: MapStatesTemplate,

  getChartData: function() {
    return window.google.visualization.arrayToDataTable(this.model.get('data'));
  },

  getChartOptions: function() {
    var color_ax = (this.model.get("display_type") == "map-li") ? ['#f3d2bc', '#d85d19'] : []

    // sniff the string always sucks :(
    var windohsCheck = function () {
      if (BrowserDetect.OS == "Windows") {
        return 'MS Sans Serif4';
      } else {
        return "";
      }
    }

    return {
      region: "US",
      resolution: "provinces",
      colorAxis: {
        minValue: 0,
        colors: color_ax
      },
      tooltip: {
        textStyle: {
          fontName: windohsCheck()
        }
      }
    };
  },

  initialize: function() {
    this.render();
  },

  render: function() {
    this.$el.html(this.template(this.model.toJSON()));

    window.google.charts.setOnLoadCallback(_.bind(this.drawChart, this));
  },

  drawChart: function() {
    this.chart = new window.google.visualization.GeoChart(document.getElementById('map-' + this.model.get('id')));
    this.chart.draw(this.getChartData(), this.getChartOptions());
  },

  destroy: function() {
    if(this.chart) {
      this.chart.clearChart();
    }
  },
});
